export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/chunks/productioncounter.worker-512bb95cb7de6615.worker.js");
}
